'use client';

import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { ArrivalOrderSlotButton } from '@/app/(main)/(pages)/_components/schedules/arrival-order/arrival-order-slot-button.component';
import { formatRelativeDay } from '@/utils/formatters/format-relative-day';
import { ScheduleSlotsDay } from '@/app/(main)/(pages)/_components/schedules/_hooks/use-schedule-slots.hook';
import { Button } from '@/components/ui/button/button.component';
import { Typography } from '@/components/ui/typography/typography.component';
import { TypographyVariant } from '@/components/ui/typography/typography.type';
import { SchedulesSearchSlot } from '@/app/(main)/(pages)/_components/schedules/_types/schedule-slot.type';
import { cn } from '@/utils/cn-tw-merge';
import { dateFormatter } from '@/utils/formatters/date';
import { getAnalyticsPlugin } from '@/app/(main)/_components/logger/analytics/get-analytics-plugin';
import { AnalyticsEnum } from '@/types/enums/analytics/analytics.enum';

const PREVIEW_SLOT_COUNT = 2;

interface ArrivalOrderTabPreviewProps {
  day: ScheduleSlotsDay | undefined;
  partnerId: string;
  price: number;
  className?: string;
  onSeeMore: () => void;
}

export function ArrivalOrderTabPreview({
  day,
  partnerId,
  price,
  className,
  onSeeMore,
}: ArrivalOrderTabPreviewProps) {
  const previewSlots = day?.slots.slice(0, PREVIEW_SLOT_COUNT) ?? [];
  const analytics = getAnalyticsPlugin();

  const handleSlotClick = (slot: SchedulesSearchSlot) => {
    analytics.track(AnalyticsEnum.CLICK_ARRIVAL_ORDER_SLOT, {
      partner_id: partnerId,
      data: slot.date,
      faixa_horario: `${dateFormatter(slot.start, 'HH:mm')} às ${dateFormatter(slot.end, 'HH:mm')}`,
      price,
    });
  };

  return (
    <div
      className={cn('flex flex-col gap-2', className)}
      data-testid={DataTestIdEnum.SEARCH_CARD_ARRIVAL_ORDER_PREVIEW}
    >
      {day && (
        <Typography variant={TypographyVariant.MEDIUM_BODY_TEXT} className="font-semibold">
          {`Próximos horários: ${formatRelativeDay(day.date)}`}
        </Typography>
      )}
      {previewSlots.length > 0 && (
        <div className="flex flex-wrap gap-2 w-full">
          {previewSlots.map((slot) => (
            <ArrivalOrderSlotButton
              key={slot.id}
              start={dateFormatter(slot.start, 'HH:mm')}
              end={dateFormatter(slot.end, 'HH:mm')}
              className="flex-1 basis-0 min-w-[120px]"
              onClick={() => handleSlotClick(slot)}
            />
          ))}
        </div>
      )}
      <Button
        variant="default"
        className="w-full h-10 py-0 text-base"
        data-testid={DataTestIdEnum.SEARCH_CARD_ARRIVAL_ORDER_OPEN_MODAL}
        onClick={onSeeMore}
      >
        Ver mais horários
      </Button>
    </div>
  );
}
